import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Employee from './pages/Employee';
import Admin from './pages/Admin';
import Verifier from './pages/Verifier';
import Navbar from './pages/Navbar'; // Import the Navbar component
import ImagePage from './pages/image';
import FileUpload from './pages/fileupload';

const App = () => {
    return (
       <Router>
       <Navbar />
             <Routes>
                 <Route path="/" element={<Home />} />
                 <Route path="/employee" element={<Employee />} />
                 <Route path="/admin" element={<Admin />} />
                  <Route path="/verifier" element={<Verifier />} />
                 {/* <Route path="/owner" element={<Owner />} /> */}
                 <Route path="/fileupload" element={<FileUpload />} />
                 <Route path="/imagepage" element={<ImagePage />} />
             </Routes>
           </Router>
    );
};

export default App;
